

















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import RujukanRanapInputModal from "@/components/modal/RujukanRanapInputModal.vue";
import { storeFaskes } from "@/store/modules/faskes";
import { storeSuratRujukanRanap } from "@/store/modules/SuratRujukanRanap";
import { storeSoap } from "@/store/modules/soap";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { getHumanDateTime } from "@/utility/DateUtils";
import SuratRujukanRanap from "@/services/SuratRujukanRanap";
import AsesmenGadarMedisStore from "@/store/modules/AsesmenAwalGadar/AsesmenGadarMedisStore";
import { alasanRujukanOptions } from "@/utility/DataReferensi";
import { storePenunjang } from "@/store/modules/penunjang";
import { isEmpty } from "lodash";
import { storeKonsul } from "@/store/modules/konsul";
import CardSuratRujukanRalan from "@/components/pemeriksaan/konsulRujukan/CardSuratRujukanRalan.vue";
import ListKonsulPasien from "@/components/ListKonsulPasien.vue";

@Component({
  components: {
    CardModalTtd,
    RujukanRanapInputModal,
    CardSuratRujukanRalan,
    ListKonsulPasien
  }
})
export default class TabKonsulRanap extends Vue {
  // @Prop() sess_login!: object;
  @Prop() register!: string;
  @Prop() rm: string;
  @Prop() openTtd: boolean;
  @Prop() openModalRujukan: boolean;
  @Prop({
    default: false
  })
  instantCreate: boolean;

  sess_login = userModule.user;
  modalOpenRujukan = false;
  btnEdit = false;
  btnCetak = false;
  btnTtd = false;
  modalOpen = false;
  pageTab = "tab-soap";
  dataRujukan: object = {};
  dtRujukan: object = {};
  responRujukan: object = {};
  tujuan: object = {};
  // tujuan = "";
  unit_tujuan_text = "";
  diagnosis = "";
  alasan = "";
  kondisi = "";
  terapi_diberikan = "";
  penunjang = "";
  terapi_diharapkan = "";

  async mounted() {
    if (this.openModalRujukan == true) {
      this.openModalInput();
    }

    await this.getRujukan();

    if (this.instantCreate) {
      this.openModalInput();
      this.$nextTick(() => {});
    } else {
      storeKonsul.actKonsul_on_reg(this.register);
    }

    storeKonsul.actKonsul_on_reg(this.register);
    storeKonsul.getKonsulMasuk(this.register);
  }
  // getHumanDateTime(date) {
  //   return date ? moment(date).format("DD MMMM YYYY HH:mm") : "";
  // }
  formatDate(date) {
    return getHumanDateTime(date);
  }
  showError(value) {
    this.$emit("err", value);
  }
  get stateuser() {
    return userModule.user;
  }

  get statesoapdetail() {
    return storeSoap.detailSoap;
  }

  get statefaskes() {
    return storeFaskes.faskes;
  }

  get stateRujukan() {
    return storeSuratRujukanRanap.rujukan;
  }

  get canMakeRujukan() {
    return ["dokter", "perawat", "bidan"].includes(
      this.stateuser.profesi?.toLowerCase()
    );
  }

  get isNeedSoap() {
    return this.stateuser.unit_id > "01" && this.stateuser.unit_id < "50";
  }

  get isSoapExist() {
    return this.statesoapdetail.length > 0;
  }

  get isUserDokter() {
    return this.stateuser?.profesi == "Dokter";
  }

  backPageSoap() {
    this.$emit("pageTab", this.pageTab);
  }

  openModalInput() {
    this.modalOpenRujukan = true;
    this.setDataInputRujukan();
  }

  get asesmenGadarMedis() {
    return AsesmenGadarMedisStore.asesmen;
  }

  get orderRadiologi() {
    return storePenunjang.listorderRadiologi;
  }

  get orderLab() {
    return storePenunjang.listorderLab;
  }

  get statedetailkonsul() {
    return storeKonsul.detailkonsul;
  }

  setDataInputRujukan() {
    if (userModule.user.unit_id == "01" && this.asesmenGadarMedis) {
      const content = this.asesmenGadarMedis.content;

      this.tujuan = this.statefaskes.find(
        item =>
          item.id == this.asesmenGadarMedis.content?.tindakLanjut?.tujuanRujukan
      );

      const alasanRujukan = alasanRujukanOptions.find(
        item => item.id == parseInt(content?.tindakLanjut?.alasanRujukan)
      );

      const orderRo = this.orderRadiologi
          .filter(order => order.unit_id == "01")
          .flatMap(order => order.items)
          .map(item => item.name)
          .join("; "),
        orderRoText = orderRo ? `Radiologi: ${orderRo}` : null;

      const orderLab = this.orderLab
          .filter(order => order.unit_id == "01")
          .flatMap(order => order.items)
          .map(item => item.name)
          .join("; "),
        orderLabText = orderLab ? `Lab: ${orderLab}` : null;

      const penunjangText = [orderRoText, orderLabText].join("\r\n");

      this.dataRujukan = {
        a: content?.diagnosis.kerja,
        unit_tujuan_text: content?.tindakLanjut.unitTujuanRujukan,
        alasan: !isEmpty(alasanRujukan)
          ? alasanRujukan.id == 5
            ? content.tindakLanjut.alasanRujukanText
            : alasanRujukan.name
          : "-",
        kondisi: null,
        terapi_diberikan: content?.terapi?.terapi,
        penunjang: penunjangText
      };
    } else {
      this.dataRujukan = {
        a: "",
        unit_tujuan_text: "",
        alasan: "",
        kondisi: "",
        terapi_diberikan: "",
        penunjang: "",
        terapi_diharapkan: "",
        dokter_id: ""
      };
      this.tujuan = this.statefaskes;
    }
  }

  // editRujukan() {
  //   // console.log("dtruj", this.stateRujukan);
  //   this.modalOpenRujukan = true;
  //   this.dataRujukan = {
  //     a: this.stateRujukan.diagnosis,
  //     tujuan: this.stateRujukan.tujuan,
  //     unit_tujuan_text: this.stateRujukan.unit_tujuan_text,
  //     alasan: this.stateRujukan.alasan,
  //     kondisi: this.stateRujukan.kondisi,
  //     terapi_diberikan: this.stateRujukan.terapi_diberikan,
  //     penunjang: this.stateRujukan.penunjang,
  //     terapi_diharapkan: this.stateRujukan.terapi_diharapkan,
  //     dokter_id: this.stateRujukan.dokter?.id
  //   };
  // }

  @Watch("dtRujukan")
  cekRujukan(v) {
    this.dtRujukan = v;
  }

  respRujukan(v) {
    this.responRujukan = v;
  }

  getRujukan() {
    storeSuratRujukanRanap.getByRegister(this.register);
  }

  modalTtd() {
    this.modalOpen = true;
  }

  async passTtd(value) {
    const resp = await SuratRujukanRanap.sign(
      storeSuratRujukanRanap.rujukan.id,
      { password: value }
    );

    if (resp.data.status == 1) {
      this.modalOpen = false;
      appModule.NoticeDelay("Berhasil Tanda Tangan Surat Rujukan");
      appModule.addMsgTtd("");
      this.getRujukan();
    } else {
      appModule.addMsgTtd(resp.data.message);
      this.modalOpen = true;
    }
  }

  reloadRujukanInternalList() {
    storeKonsul.actKonsul_on_reg(this.register);
    // storeKonsul.getKonsulMasuk(this.register);
  }
}
